import Theme from 'Theme';
import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        alignItems: 'flex-end',
        borderRadius: 4,
        backgroundColor: '#E20074',
        justifyContent: 'center',
        alignSelf: 'center'
    },
    textContainer: {
        fontFamily: Theme.regularFont,
        letterSpacing: 0.4,
        color: 'white',
        textAlign: 'right',
        fontSize: 10,
        paddingHorizontal: 4
    },
    itemContainer: {
        height: 2
    }
};

export default StyleSheet.create(baseStyles);
